var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHotelBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7352 13.6897C18.7057 11.3795 17.7838 9.21228 16.1395 7.58732C14.6894 6.15443 12.824 5.28904 10.8181 5.1033C10.8675 4.99221 10.8951 4.86936 10.8951 4.7399C10.8951 4.24467 10.4937 3.84326 9.99848 3.84326C9.50324 3.84326 9.10184 4.24471 9.10184 4.7399C9.10184 4.86928 9.12945 4.99217 9.17883 5.1033C7.17297 5.28904 5.30758 6.15443 3.8575 7.58732C2.21312 9.21225 1.29129 11.3795 1.2618 13.6897L1.25391 14.3097H18.7431L18.7352 13.6897ZM2.51969 13.0853C2.88449 9.28537 6.1173 6.28963 9.99844 6.28963C13.8796 6.28963 17.1124 9.28537 17.4771 13.0853H2.51969Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14.9324H0V16.1569H20V14.9324Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8125 11.902L4.99832 12.2074C5.0041 12.185 5.59938 9.95157 7.5477 9.10345L7.05898 7.98071C4.56875 9.0647 3.84227 11.7867 3.8125 11.902Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelBell);
export default __webpack_public_path__ + "static/media/hotelBell.84c592b9bcac1db4ab3d1fdd63a3030f.svg";
export { ForwardRef as ReactComponent };